__turbopack_context__.v({
  "contactFormWrapper": "contact-form-module__mg78PW__contactFormWrapper",
  "error": "contact-form-module__mg78PW__error",
  "formGroup": "contact-form-module__mg78PW__formGroup",
  "formInput": "contact-form-module__mg78PW__formInput",
  "formLabel": "contact-form-module__mg78PW__formLabel",
  "formRow": "contact-form-module__mg78PW__formRow",
  "formTextarea": "contact-form-module__mg78PW__formTextarea",
  "required": "contact-form-module__mg78PW__required",
  "slideIn": "contact-form-module__mg78PW__slideIn",
  "spin": "contact-form-module__mg78PW__spin",
  "spinner": "contact-form-module__mg78PW__spinner",
  "submitButton": "contact-form-module__mg78PW__submitButton",
  "success": "contact-form-module__mg78PW__success",
  "toastIcon": "contact-form-module__mg78PW__toastIcon",
  "toastMessage": "contact-form-module__mg78PW__toastMessage",
});
